import i18next, { TOptions } from "i18next";

export const getTranslateNsT =
  (ns: string | string[], options?: TOptions) => (key: string) =>
    i18next.t(key, { ns, ...options });
